

















import { Component, Vue } from "vue-property-decorator"

@Component
export default class App extends Vue {
  /** current scale factor for font-size */
  protected scale = 1

  /** scale factor for font-size before an ongoing pinch gesture was started */
  protected startScale = 1

  /** min scale factor for font-zooming */
  protected minScale = 0.8

  /** max scale factor for font-zooming */
  protected maxScale = 2

  protected get scaleStyle() {
    return {
      "font-size": this.scale * 100 + "%",
    }
  }

  public onPinchStart(event: any) {
    // remember the scale when we started a pinch gesture action (finger down)
    this.startScale = this.scale
    // console.log("***start!", event, event.scale, this.scale)
  }

  public onPinch(event: any) {
    // adjust the scale relative to the scale when the gesture started
    this.scale = Math.max(this.minScale, Math.min(this.startScale * event.scale, this.maxScale))
    // console.log("pinch", event, event.scale, this.scale)
  }
}
